

export class LeaveDto implements ILeaveDto {
    id!: number;
    leaveName!: string | undefined;
    shortCode!: string | undefined;
    leaveMaxMinutes!: number;
    isActive!: boolean;
    isPaid!: boolean;
    monthlyEarn!: number;
    isShowBalance!: boolean;
    maxCarryForward!: number;
    isEncashLeave!: boolean;
    yearlyEarn!: number;
    isForContract!: boolean;

    constructor(data?: ILeaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.leaveName = _data["leaveName"];
            this.shortCode = _data["shortCode"];
            this.leaveMaxMinutes = _data["leaveMaxMinutes"];
            this.isActive = _data["isActive"];
            this.isPaid = _data["isPaid"];
            this.monthlyEarn = _data["monthlyEarn"];
            this.isShowBalance = _data["isShowBalance"];
            this.maxCarryForward = _data["maxCarryForward"];
            this.isEncashLeave = _data["isEncashLeave"];
            this.yearlyEarn = _data["yearlyEarn"];
            this.isForContract = _data["isForContract"];
        }
    }

    static fromJS(data: any): LeaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["leaveName"] = this.leaveName;
        data["shortCode"] = this.shortCode;
        data["leaveMaxMinutes"] = this.leaveMaxMinutes;
        data["isActive"] = this.isActive;
        data["isPaid"] = this.isPaid;
        data["monthlyEarn"] = this.monthlyEarn;
        data["isShowBalance"] = this.isShowBalance;
        data["maxCarryForward"] = this.maxCarryForward;
        data["isEncashLeave"] = this.isEncashLeave;
        data["yearlyEarn"] = this.yearlyEarn;
        data["isForContract"] = this.isForContract;
        return data; 
    }
}

export interface ILeaveDto {
    id: number;
    leaveName: string | undefined;
    shortCode: string | undefined;
    leaveMaxMinutes: number;
    isActive: boolean;
    isPaid: boolean;
    monthlyEarn: number;
    isShowBalance: boolean;
    maxCarryForward: number;
    isEncashLeave: boolean;
    yearlyEarn: number;
    isForContract: boolean;
}

